import { useTranslations } from 'next-intl';
import classNames from 'classnames';
import { Checkbox, CheckboxSize, CheckboxType } from '@nx-frontend/shared/ui/checkbox';

interface PageStabProps {
  className?: string;
  isCustomizerMode?: boolean;
  handlePageVisible?: () => void;
}

export const PageStab: React.FC<PageStabProps> = ({ handlePageVisible, isCustomizerMode, className }) => {
  const t = useTranslations('shared');
  return (
    <div
      className={classNames(
        'fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white z-20',
        className
      )}
    >
      <div className="p-6 rounded-lg text-center max-w-lg">
        <h2 className="text-2xl font-bold mb-6">
          {isCustomizerMode ? 'This Page is Not Yet Live' : t('page-stub.this_page_is_invisible')}
        </h2>
        <p className="text-gray-600 text-[16px] tracking-wider">
          {isCustomizerMode
            ? 'To see this page, please go back to the Portal Editor, change the visibility status and publish the portal'
            : t('page-stub.invisible_page_description')}
        </p>
        {handlePageVisible && (
          <div className="flex items-center justify-center p-4">
            <Checkbox
              id="page-stab"
              label="&nbsp;&nbsp;Visibility"
              checked={false}
              onChange={handlePageVisible}
              type={CheckboxType.SWITCH}
              boxSize={CheckboxSize.LG}
            />
          </div>
        )}
      </div>
    </div>
  );
};
